<template>
  <div class="main">
    <!-- banner -->
    <div class="ban" style="background-image: url('/images/ba0c1eb35598ad0d34d9ae0c732651fa.jpg');"></div>
    <!-- banner-end -->
    <!-- 内容 -->
    <div class="wp">
      <div class="g-top">
        <div class="cur">
          当前位置：
          <a href="/">首页</a>&gt;
          <a href="javascript:void(0)">搜索结果</a> &gt;
          <span>{{ $route.query.keyword }}</span>
        </div>
      </div>


      <div class="g-content">
          <div  v-for="(item,index) in resultList"  v-if="resultList.length !=  0" class="g-item" :key="index" @click="handleClick(item)">
             <h3>{{item.chipNameCn}}</h3>
             
          </div>
          <div v-if="resultList.length == 0" class="g-none">暂无数据</div>
      </div>
    </div>


  </div>
</template>

<script>
import RequestUtil from '../utils/request';
export default {
  name: 'Result',
  data() {
    return {
        resultList: []
    }
  },
  mounted() {

   this.keyword = this.$route.query.keyword;
   this.getResultListByKeyword();
  

  },
  
     watch: {
    // 监听路由变化
  '$route'(to, from) {
      const { keyword } = to.query;
       this.keyword = keyword;
        this.getResultListByKeyword();
    
    }
  },
  methods: {
        handleClick(item) {
    
           RequestUtil.get('/wx/product/eleChipInfoByParentIdByWeb?parentId=' + item.parentId).then(res => {
            let width = window.innerWidth
            if (width > 1100) {
              this.$router.push({ path: '/product-center', query: { defaultActive: item.chipId, id: res.data } });
            }else{
              this.$router.push({ path: '/product-center', query: { type: "mobile_show_table", parentId: item.chipId,timestamp: new Date().getTime() } });
            }
            //  http://localhost:8080/#/product-center?timestamp=1769885929091&type=mobile_show_table&parentId=225
          })
          
        },
        getResultListByKeyword() {
          RequestUtil.get('/wx/product/eleChipInfoByKeyWordByWeb?keyWord=' + this.keyword).then(res => {
            this.resultList = res.data
          })
        }
  }
}
</script>

<style scoped>
      .g-content{
        padding: 40px 0;
        min-height:  30vh;
      }
      .g-none{
        width: 100%;
        text-align: center;
        color: #d3d3d3;
    
        height: 100px;
        font-size: 16px;
      }

      @media only screen and (min-width: 1199px) {
        .g-content{
          display: flex;
          flex-wrap: wrap;
          /* justify-content: space-between; */
         gap: 1vw;
         
        }

        .g-item{
          width: calc(100% / 4 - 0.8vw);
          background-color: #E8EDF3;
          height: 3.645vw;
          line-height: 3.645vw;
          font-size: 1.041vw;
          /* width: 25%; */
          box-sizing: border-box;
          text-align: center;
          margin-bottom: 1vw;
          cursor: pointer;
         
          
        }
          .g-item:hover{
            background-color: #007DC7;
            color: #fff;
          }
  
    }


      @media only screen and (max-width: 1199px) {

         .g-content{
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
         gap: 2vw;
         
        }

        .g-item{
          width: calc(100% / 2 - 1.8vw);
          background-color: #E8EDF3;
          height: 40px;
        line-height: 40px;
        font-size: 12px;
          /* width: 25%; */
          box-sizing: border-box;
          text-align: center;
          margin-bottom: 1vw;
         
          
        }
      }
</style>